module.exports = __webpack_public_path__ + "img/slots36.cc09e955.jpg";